'use client';

import React, { PropsWithChildren, useState } from 'react';
import { ErrorBoundary as ReactErrorBoundary, ErrorBoundaryProps } from 'react-error-boundary';

import { Toast, ToastProvider } from '@videoblocks/design-system';

const defaultFallbackRender = ({ error, resetErrorBoundary }) => (
    <div role="alert">
        <p>Something went wrong:</p>
        <pre style={{ color: 'red' }}>{error.message}</pre>
        <button onClick={resetErrorBoundary}>Try again</button>
    </div>
);

export const ErrorBoundary = ({
    children,
    fallbackRender,
    onError,
}: PropsWithChildren & Partial<ErrorBoundaryProps>) => {
    const [errorMessage, setErrorMessage] = useState<string>('');

    return (
        <ReactErrorBoundary
            fallbackRender={fallbackRender || defaultFallbackRender}
            onError={(error, errorInfo) => {
                onError?.(error, errorInfo);
                setErrorMessage(error.message);
            }}
        >
            <ToastProvider>
                {!!errorMessage && (
                    <Toast
                        open
                        title={errorMessage}
                        variant="error"
                        duration={Infinity}
                        viewportClassName="fixed top-[var(--spacing-24)] right-[var(--spacing-6)] flex flex-col gap-[var(--spacing-2)] w-fit max-w-[calc(100vw-var(--spacing-12))] m-0 list-none z-[1050] outline-none"
                    />
                )}
                {children}
            </ToastProvider>
        </ReactErrorBoundary>
    );
};
